export default __webpack_public_path__ + "static/media/add-folder.b04e2d60.svg";